<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>{{ title }}
        <button type="button" class="close"
                @click.prevent="closeModal()">
          <span aria-hidden="true">&times;</span></button>
      </h5>
    </div>
    <b-form @submit.prevent="save()">
      <div class="container-fluid visit-charge-body">
        <div class="row justify-content-center m-2">
          <div class="alert alert-danger col" role="alert" v-show="generalErrorMessage">
            <div>{{ generalErrorMessage }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-2">
          </div>
          <div class="col-8">
            <b-form-group :label-cols="4"
                          label="Location"
                          :state="stateForField('locationId')"
                          :invalid-feedback="errorForField('locationId')"
                          label-class="text-right">
              <b-dropdown menu-class="dropdown-container" :text="locationName"
                          :variant="hasError('locationId') ? 'outline-danger' : 'outline-dark'">
                <b-dropdown-item v-for="location in locations" :key="location.locationId"
                                 @click.prevent="setLocation(location)">{{ location.name + ' (' + location.type + ')' }}
                </b-dropdown-item>
              </b-dropdown>
            </b-form-group>
            <b-form-group :label-cols="4"
                          label="Provider"
                          :state="stateForField('providerId')"
                          :invalid-feedback="errorForField('providerId')"
                          label-class="text-right">
              <b-dropdown menu-class="dropdown-container" :text="providerName"
                          :variant="hasError('providerId') ? 'outline-danger' : 'outline-dark'">
                <b-dropdown-item v-for="provider in providers" :key="provider.organizationProviderId"
                                 @click.prevent="setProvider(provider)">{{ provider.displayName }}
                </b-dropdown-item>
              </b-dropdown>
            </b-form-group>
            <b-form-group v-if="employerBenefits?.length === 1" :label-cols="4"
                          label="Episode Library"
                          label-class="text-right">
              <div class="mt-2">{{ episodeLibraryName }}</div>
            </b-form-group>
            <b-form-group
                v-if="employerBenefits?.length > 1"
                :label-cols="4"
                label="Payor"
                :state="stateForField('organizationEmployerId')"
                :invalid-feedback="errorForField('organizationEmployerId')"
                label-class="text-right">
              <b-dropdown  menu-class="dropdown-container" :text="employerBenefitName"
                           :variant="hasError('organizationEmployerId') ? 'outline-danger' : 'outline-dark'">
                <b-dropdown-item v-for="employerBenefit in employerBenefits" :key="employerBenefit.organizationPatientEmployerBenefitId"
                                 @click.prevent="setEmployerBenefit(employerBenefit)">{{employerBenefit.organizationEmployer.name}}
                </b-dropdown-item>
              </b-dropdown>
            </b-form-group>
            <b-form-group :label-cols="4" label="Lead Code" label-align="right" :state="stateForField('leadCode')" :invalid-feedback="errorForField('leadCode')">
              <b-form-input v-model="estimate.leadCode"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" label="Lead Code Modifier" label-align="right" :state="stateForField('leadCodeModifier')" :invalid-feedback="errorForField('leadCodeModifier')">
              <b-form-input v-model="estimate.leadCodeModifier"></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div v-if="bundlesEnabled" class="row">
          <div class="col-2"></div>
          <div class="col-8">
            <div class="form-row">
              <div class="col-4"></div>
              <div class="col"><h6>Matching Episodic Fees</h6></div>
            </div>
            <div v-for="bundle in matchingBundles" :key="bundle.organizationBundleId" class="form-row bundle-box">
              <div class="col-1 mx-2 my-2">
                <div class="bundle-selection">
                  <font-awesome-icon @click="selectBundle(bundle)" class="align-middle" v-if="estimate.organizationBundleId !== bundle.organizationBundleId" :icon="['far', 'circle']"/>
                  <font-awesome-icon @click="unselectBundle(bundle)" class="align-middle" v-if="estimate.organizationBundleId === bundle.organizationBundleId" :icon="[ 'far', 'check-circle']"/>
                </div>
              </div>
              <div class="col my-2">
                  <div><h2 class="mb-0">{{ bundle.name }}
                    <button onclick="return false" :id="`target-` + bundle.organizationBundleId" class="popover-text"><font-awesome-icon :icon="['far', 'circle-info']" />
                    </button>
                    <b-popover custom-class="wide-popover" :target="`target-` + bundle.organizationBundleId" triggers="hover" placement="bottomright">
                      <div><b>Description: </b>{{bundle.description}}</div><br>
                      <div v-if="bundle.bundleType === 'Employer'"><b>Employer/TPA: </b>{{ bundle.employer.name }}</div>
                    </b-popover>
                  </h2>
             </div>
                  <div><span class="field-label">Amount: </span>${{formatNumber(bundle.amount)}}</div>
                  <div class="codes"> <span class="field-label">Episodic Codes: </span>&nbsp;{{ displayCode(bundle) }}
                    <div v-for="(code, index) in bundle.codes" v-if="bundle.codes" :key="'code-' + index">, {{code.code}}</div>
                  </div>
              </div>
            </div>
            <div v-if="!matchingBundles || matchingBundles?.length === 0">
              No episodic fees
            </div>
          </div>
        </div>

      </div>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-orange float-right" @click.prevent="save()">
        <font-awesome-icon size="lg" class="mr-2" v-show="isSaving" icon="spinner" pulse/>
        Save Episode
      </button>
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>
  </b-modal>
</template>

<script>
  import api from '../services/api'
  import ErrorsMixin from '../mixins/ErrorsMixin.js'

  export default {
    name: 'NewEpisodeModal',

    mixins: [ErrorsMixin],

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      patientId: {
        type: Number,
        required: true
      },

      bundles: {
        type: Array,
        required: false
      },

      employers: {
        type: Array,
        required: false
      },

      employerBenefits: {
        type: Array,
        required: false
      },

      title: {
        type: String,
        default: 'Create Episode'
      },

      patientHasEmployerBundle: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        estimate: {
          locationId: null,
          providerId: null,
          organizationPatientId: null,
          leadCode: '',
          organizationBundleId: 0,
          organizationEmployerId: 0,
          hasImplant: false,
          leadCodeModifier: ''
        },
        organizationEmployer: {},
        isSaving: false,
        showingDescription: false,
        locationName: 'Click to select',
        providerName: 'Click to select',
        employerName: 'Select a payor',
        bundleType: [
          { value: 1, text: 'SelfPay' },
          { value: 2, text: 'Employer' }
        ],
        yesNoOptions: [
          { value: true, text: 'Yes' },
          { value: false, text: 'No' }
        ]
      }
    },

    watch: {
      visible (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.clearData()
        }
      },

      'employerBenefits' (newValue) {
        if (newValue && newValue.length === 1) {
          this.estimate.organizationEmployerId = newValue[0].organizationEmployer.organizationEmployerId
        } else {
          this.estimate.organizationEmployerId = 0
        }
      },

      'estimate.leadCode' (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.estimate.organizationBundleId = 0
        }
      },

      'estimate.leadCodeModifier' (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.estimate.organizationBundleId = 0
        }
      }
    },

    computed: {
      episodeLibraryName () {
        if (this.estimate.organizationEmployerId && this.employerBenefits?.length === 1) {
          return this.employerBenefits[0].organizationEmployer.name
        }
        return ''
      },
      providers () {
        return this.$store.organization.providers
      },

      locations () {
        return this.$store.organization.locations
      },

      bundlesEnabled () {
        return this.bundles && this.bundles?.length > 0
      },

      selfPayBundles () {
        if (this.patientHasEmployerBundle === false) {
          return this.bundles.filter(bundle => bundle.bundleType === 'SelfPay')
        }
        return []
      },

      employerBundles () {
        if (this.employerBenefits?.length === 1) {
          return this.bundles.filter(bundle => bundle.organizationEmployerId === this.employerBenefits[0].organizationEmployer.organizationEmployerId)
        }
        if (this.estimate.organizationEmployerId && (this.employerBenefits?.length === 0 || this.employerBenefits?.length > 1)) {
          return this.bundles.filter(bundle => bundle.organizationEmployerId === this.estimate.organizationEmployerId)
        }
        return []
      },

      matchingBundles () {
        if (this.bundles && this.employerBundles.length > 0) {
          return this.employerBundles.filter((aBundle) => {
            const matchesCode = aBundle.code === this.estimate.leadCode
            const locations = aBundle.locations || []
            const matchesLocation =
              locations?.length === 0 ||
              locations.some(location => location.locationId === this.estimate.locationId)
            return matchesCode && matchesLocation
          })
        }
        if (this.bundles && this.selfPayBundles.length > 0) {
          return this.selfPayBundles.filter((aBundle) => {
            const matchesCode = aBundle.code === this.estimate.leadCode
            const locations = aBundle.locations || []
            const matchesLocation =
              locations?.length === 0 ||
              locations.some(location => location.locationId === this.estimate.locationId)
            return matchesCode && matchesLocation
          })
        } else {
          return []
        }
      },

      selectedBundle () {
        if (!this.bundles) {
          return null
        }

        const bundle = this.matchingBundles.filter((aBundle) => {
          return this.estimate.organizationBundleId === aBundle.organizationBundleId
        }).shift()

        if (bundle) {
          return bundle
        }

        return null
      }
    },

    methods: {
      clearData () {
        this.clearAllErrors()
        this.estimate = {
          locationId: null,
          providerId: null,
          organizationEmployerId: null,
          organizationPatientId: this.patientId,
          leadCode: '',
          organizationBundleId: 0,
          leadCodeModifier: ''
        }
        if (this.employer) {
          this.estimate.organizationEmployerId = this.employer.organizationEmployerId
        }
        this.providerName = 'Click to select'
        this.locationName = 'Click to select'
        this.employerName = 'Select a payor'
        this.employerBenefitName = 'Select a payor'
      },

      validate () {
        this.clearAllErrors()

        if (!this.estimate.providerId > 0) {
          this.addErrorForField('providerId', 'You must select a provider')
        }

        if (!this.estimate.locationId > 0) {
          this.addErrorForField('locationId', 'You must select a location')
        }

        if (this.employerBenefits > 0 && !this.estimate.organizationEmployerId) {
          this.addErrorForField('organizationEmployerId', 'You must select a payor')
        }

        if (!this.estimate.organizationBundleId) {
          this.addErrorForField('exception', 'You must select a bundle')
        }

        return !this.hasErrors()
      },

      setLocation (location) {
        this.estimate.locationId = location.locationId
        this.locationName = location.name
      },

      setProvider (provider) {
        this.estimate.providerId = provider.providerId
        this.providerName = provider.displayName
      },

      setEmployer (employer) {
        this.estimate.organizationEmployerId = employer.organizationEmployerId
        this.employerName = employer.name
      },

      setEmployerBenefit (employerBenefit) {
        if (this.employerBenefits) {
          this.estimate.organizationEmployerId = employerBenefit.organizationEmployer.organizationEmployerId
          this.employerBenefitName = employerBenefit.organizationEmployer.name
        }
      },

      selectBundle (bundle) {
        this.estimate.organizationBundleId = bundle.organizationBundleId
        if (bundle.bundleHasImplant === true && bundle.implantCostIncluded === false) {
          this.estimate.hasImplant = true
        }
      },

      unselectBundle (bundle) {
        this.estimate.organizationBundleId = 0
      },

      displayCode (bundle) {
        if (bundle.modifier) {
          return bundle.code + '-' + bundle.modifier
        }

        return bundle.code
      },

      formatNumber (number) {
        if (number === 0 || number === 0.0) {
          return '0.00'
        }
        if (number) {
          return number.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        }

        return ''
      },

      save () {
        if (this.isSaving) {
          return
        }
        if (!this.validate()) {
          return
        }
        this.isSaving = true
        this.errorMessage = ''
        api.post('/Dashboard/Estimate', this.estimate, { timeout: 120000 }).then(response => {
          this.$emit('estimateCreated', response.data)
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.$log.error('Error attempting to add estimate: ' + error.message, error)
          }
        }).then(() => {
          this.isSaving = false
        })
      },

      closeModal () {
        this.$emit('update:visible', false)
      }
    }
  }
</script>

<style scoped>
.visit-charge-body {
  font-size: 16px;
}

.current-charge .fa-trash-alt {
  cursor: pointer;
}

.current-charge .fa-trash-alt:HOVER {
  color: rgb(255, 70, 0);
}

.bundle-box {
  border-radius: 8px;
  border: #ced4da solid 1px;
  padding: 0.5em;
  background-color: #f9f9f9;
  margin-bottom: 10px;
}

.bundle-selection {
  height: 100%;
  display: flex;
  justify-content: center;
}

.bundle-selection .svg-inline--fa {
  height: 2em;
  color: rgb(255, 70, 0);
  cursor: pointer;
}

.bundle-selection svg {
  display: block;
}
h2 {
  font-size: 18px;
}
.codes {
  display:flex;
}
.popover-text {
  background-color: #f9f9f9;
  border: none;
  color: rgb(82, 140, 197);
  font-size: 14px;
  padding-left: 1px;
}
</style>
